import {
  CornerUpRight, BellRing, BellCheck, ArrowRight, Flame,
  PanelLeft, PanelRight,
  MessageSquare,
  Home, Search, Bell, Mail, Bookmark, Settings, MoreHorizontal, X, ChevronDown, ChevronRight,
  ChevronLeft, ZoomIn, ZoomOut,
  Heart, Shield, Check, Users, Sparkles, Plus, Sun, Moon,
  Compass, Crown, User, UsersRound, LogOut,
  Flag, Image, Smile, BarChart3, CalendarClock, Globe, Hourglass, Ban,
  ArrowLeft, Reply, Pencil, Trash2, AtSign, UserPlus,
  MapPin, Link2, LayoutGrid, List, Lock, Award, Star,
  Palette, Volume2, SlidersHorizontal, Database, Accessibility, Info,
  FileText, Video, Newspaper, Package, Folder, FolderPlus,
  TrendingUp, Repeat, Code, Headset,
  Phone, Paperclip, Mic,
  Gauge, UserCheck, UserX, Hash, Activity, PieChart, KeyRound, Archive, Megaphone, Wrench, RefreshCw, Clock, Download,
  Inbox, Play, Pause, Maximize, Minimize, Send, Radio,
  EyeOff, VolumeX, MonitorPlay,
  Upload, Pin, ArrowUp, ArrowDown, Quote,
  Bold, Italic, ListOrdered, Eye,
  HeartHandshake,
  Gamepad2, GraduationCap, Music, Cpu, Trophy, Clapperboard,
  RotateCcw, RotateCw, Volume1, Captions, PictureInPicture2, ListVideo, Keyboard, ThumbsUp,
  ThumbsDown, Scissors, ChevronUp, Timer, Repeat1, Crop, ListPlus, BellOff, Loader2,
  AudioLines, MessageSquareText, Zap, TriangleAlert, EllipsisVertical,
  Camera, Copy, GripVertical, Smartphone, Monitor, Cake, Briefcase, ExternalLink,
} from 'lucide-react';
import type { ComponentType } from 'react';
import { LogoX } from './brand/LogoX';
import { LogoWhatsApp } from './brand/LogoWhatsApp';
import { LogoTelegram } from './brand/LogoTelegram';
import { LogoFacebook } from './brand/LogoFacebook';
import { LogoReddit } from './brand/LogoReddit';
import { SignalMark } from './brand/SignalMark';
import { Cherish } from './brand/Cherish';
import { SpreadIt } from './brand/SpreadIt';
import { Verify } from './brand/Verify';
import { SupporterBadge } from './brand/SupporterBadge';
import { FeedbackMark } from './brand/FeedbackMark';
import { LogoGoogle } from './brand/LogoGoogle';
import { LogoApple } from './brand/LogoApple';

type IconComponent = ComponentType<{ size?: number }>;

export const icons = {
  'arrow-right': ArrowRight, flame: Flame,
  'panel-left': PanelLeft, 'panel-right': PanelRight,
  'bell-ringing': BellRing, 'bell-check': BellCheck,
  home: Home, search: Search, bell: Bell, mail: Mail, bookmark: Bookmark, settings: Settings,
  'more-horizontal': MoreHorizontal, close: X, 'chevron-down': ChevronDown, 'chevron-right': ChevronRight,
  'chevron-left': ChevronLeft, 'zoom-in': ZoomIn, 'zoom-out': ZoomOut,
  heart: Heart, comment: MessageSquare, share: CornerUpRight, shield: Shield, check: Check, users: Users,
  sparkles: Sparkles, plus: Plus, sun: Sun, moon: Moon,
  compass: Compass, crown: Crown, user: User, 'users-round': UsersRound, logout: LogOut,
  'logo-x': LogoX, signal: SignalMark, cherish: Cherish, 'spread-it': SpreadIt, verify: Verify,
  'supporter-badge': SupporterBadge,
  flag: Flag, image: Image, smile: Smile, 'bar-chart-3': BarChart3,
  'calendar-clock': CalendarClock, globe: Globe, hourglass: Hourglass, ban: Ban,
  'arrow-left': ArrowLeft, reply: Reply, edit: Pencil, trash: Trash2, 'at-sign': AtSign, 'user-plus': UserPlus,
  'map-pin': MapPin, link: Link2, 'layout-grid': LayoutGrid, list: List, lock: Lock, award: Award, star: Star,
  palette: Palette, 'volume-2': Volume2, 'sliders-horizontal': SlidersHorizontal,
  database: Database, accessibility: Accessibility, info: Info,
  'file-text': FileText, video: Video, newspaper: Newspaper, package: Package,
  folder: Folder, 'folder-plus': FolderPlus,
  'trending-up': TrendingUp, repeat: Repeat, code: Code, headset: Headset,
  phone: Phone, paperclip: Paperclip, mic: Mic,
  gauge: Gauge, 'user-check': UserCheck, 'user-x': UserX, hash: Hash, activity: Activity,
  'pie-chart': PieChart, key: KeyRound, archive: Archive, megaphone: Megaphone,
  wrench: Wrench, refresh: RefreshCw, clock: Clock, download: Download,
  inbox: Inbox,
  // Speech bubble with lines — the feedback board (distinct from `comment`,
  // which is the per-post reply action).
  feedback: FeedbackMark,
  play: Play,
  pause: Pause,
  maximize: Maximize,
  minimize: Minimize,
  send: Send,
  radio: Radio,
  'eye-off': EyeOff,
  'volume-x': VolumeX,
  theater: MonitorPlay,
  upload: Upload,
  pin: Pin,
  'arrow-up': ArrowUp,
  'arrow-down': ArrowDown,
  quote: Quote,
  bold: Bold,
  italic: Italic,
  'list-ordered': ListOrdered,
  eye: Eye,
  // Support page (Growth slice, 1.21.60) + the Support nav entry.
  support: HeartHandshake,
  // Videos page chips (2026-09-26).
  gamepad: Gamepad2,
  'graduation-cap': GraduationCap,
  music: Music,
  cpu: Cpu,
  trophy: Trophy,
  clapperboard: Clapperboard,
  // Video player + watch page v2 + Flash (1.27.50).
  'rotate-ccw': RotateCcw,
  'rotate-cw': RotateCw,
  'volume-1': Volume1,
  captions: Captions,
  pip: PictureInPicture2,
  chapters: ListVideo,
  keyboard: Keyboard,
  'thumbs-up': ThumbsUp,
  'thumbs-down': ThumbsDown,
  scissors: Scissors,
  'chevron-up': ChevronUp,
  timer: Timer,
  'repeat-1': Repeat1,
  crop: Crop,
  'list-plus': ListPlus,
  'bell-off': BellOff,
  spinner: Loader2,
  'audio-lines': AudioLines,
  'message-text': MessageSquareText,
  flash: Zap,
  alert: TriangleAlert,
  'more-vertical': EllipsisVertical,
  // Share-sheet brand marks (1.23.90 SharePostDialog). Hand-rolled monochrome
  // SVGs under brand/ — the installed lucide-react ships no brand glyphs, and
  // the tiles need currentColor ink so they theme via tokens. `logo-x` above
  // is the fifth.
  'logo-whatsapp': LogoWhatsApp,
  'logo-telegram': LogoTelegram,
  'logo-facebook': LogoFacebook,
  'logo-reddit': LogoReddit,
  // 1.27.70 Account Settings (Connected Accounts tiles) + Edit Profile page.
  'logo-google': LogoGoogle,
  'logo-apple': LogoApple,
  camera: Camera,
  copy: Copy,
  'grip-vertical': GripVertical,
  smartphone: Smartphone,
  monitor: Monitor,
  cake: Cake,
  briefcase: Briefcase,
  'external-link': ExternalLink,
} satisfies Record<string, IconComponent>;

export type IconName = keyof typeof icons;
